<template>
  <div :style="changeFont" :class="[hasKiosk?'min-h-screen':'min-h-full']">
    <div id="timeOutClickable">
      <div
        :class="[
          'h-screen test xl:items-center',
          this.$route.name == 'DeliveryStart' ? '' : ' overflow-hidden',
          isThemeLoading && 'hidden',
        ]"
        :style="cardSecondaryBackground"
      >
        <div
          id="app"
          :class="['lg:pb-5 mb-auto', isSwipeOpen ? 'overflow-hidden' : '']"
        >
          <v-dialog />
          <div
            class="flex justify-center h-auto"
            v-if="this.$route.params.menuHash != undefined"
          >
            <div
              :class="[
                'w-full ',
                isCartViewShown ? 'md:w-3/3' : hasKiosk&&'md:w-4/5',
                this.$route.name != 'UserDetails' &&
                this.$route.name != 'Payment'
                  ? ''
                  : '',
                hasKiosk ? '' : 'md:h-screen',
              ]"
              :style="
                this.$route.name != 'PickUpScreen'
                  ? backgroundMain + landingsPageSelectionBackgroundUrl + backgroundMainFullImage
                  : 'background: white;'
              "
            >
              <div
              v-if="hasKiosk"
                :class="[
                  'w-1/3 text-center hidden bg-opacity-90 rounded-r-2large pt-6',
                ]"
              >
                <div v-if="this.$route.name == 'Home'"><Header /></div>
              </div>
              <div
              v-else
                :class="[
                  'w-1/3 text-center hidden bg-opacity-90 rounded-r-2large pt-6',
                ]"
              >
                <div v-if="this.$route.name == 'Home'">
                  <Header :infiniteScroll="infiniteScroll" />
                </div>
              </div>
              <!-- 1ste -->
              <div
                v-show="
                  this.$route.name !== 'KioskStart' &&
                  this.$route.name !== 'HomeScreenKiosk' &&
                  this.$route.name !== 'DeliveryStart' &&
                  this.$route.name !== 'PickUpScreen' &&
                  !this.$route.meta.embedded
                "
                id="restaurant-header"
                class="rounded-t-lg mt-4 items-center flex justify-center md:w-11/12 mt-6 mb-6 mx-auto relative h-24"
                :style="
                menu.layout == 'frydate' && this.$route.name !== 'Home' && this.$route.name !== 'OrderDetails' ? 
                (isMobileDevice ? 'margin: 0; padding:0;' : 'margin: 0; padding:0;' + cartHeaderHeight) : (isMobileDevice ? '' : cartHeaderHeight)
                "
              >
                <!-- arrow back to homescreen -->
                <div
                  v-show="
                    this.$route.name !== 'OrderDetails' &&
                    this.$route.name !== 'Home' &&
                    isSwipeOpen != true &&
                    !hasKiosk
                  "
                  class="bg-primary-100 ml-4 rounded-xl self-center absolute top-0 left-0"
                  :style="btnThirdBackground"
                >
                  <a
                    @click="
                      $router.push({
                        path: `/${menuHash}/${!hasKiosk && stickerId ? stickerId : ''}`
                        ,query:$route.query
                      })
                    "
                    class="flex self-center items-center pl-2 pr-2 w-20"
                  >
                    <IconBackArrow
                      :fill="buttonImgColors"
                    />
                    <p
                      :class="['mr-2 text-primary-400', menu.layout == 'frydate' ? 'text-lg' : 'text-xs']"
                      :style="btnThirdText"
                    >
                      Menu
                    </p>
                  </a>
                </div>
                <!-- v-if="hasKiosk && menu.is_kiosk_horiz_categ" -->
                <div
                v-if="hasKiosk &&menu.is_kiosk_take_away_enabled && menu.is_kiosk_dine_in_enabled"
                  :class="['cursor-pointer absolute left-0',  this.$route.name !== 'Home' && this.$route.name !== 'OrderDetails' && menu.layout == 'frydate' ? 'hidden md:block self-stretch w-88 pl-8 uppercase text-xl pt-8' : '', menu.layout == 'frydate' && cartHeaderHeight ? 'md:flex' : '']"
                  :style="
                  menu.layout == 'frydate' && !isSearchKiosk && this.$route.name !== 'Home' && this.$route.name !== 'OrderDetails'? leftCategoryNavigationBackground : ''
                  "
                >
                  <div
                    v-if="
                      menu.enable_delivery ||
                      (hasKiosk && this.$route.name != 'OrderDetails')
                    "
                    class="hidden md:block w-full mx-auto"
                  >
                    <a
                      @click="$modal.show('orderType')"
                      :class="['rounded-xxl w-full flex items-center',
                      menu.layout == 'frydate' && this.$route.name !== 'Home' ? 'justify-start' : 'justify-center',
                      menu.layout == 'frydate' && cartHeaderHeight ? 'h-full' : ''
                      ]"
                      :style="makeStyles(hasKiosk&&languageButtonRadius,menu.layout == 'frydate' && !isSearchKiosk? leftCategoryNavigationBackground : headerButtonBackground)
                      "
                    >
                    <span
                    v-if="currentKioskMode == lang['take_away'][language]"
                    >
                      <img v-if="menu.custom_small_dine_in_icon" class="h-9 p-1 ml-1" :src="menu.custom_small_dine_in_icon" alt="Dine In"/>
                      <IconTruck v-else
                        classes="h-9 p-1"
                        :stroke="smallOrderTypeIconColor"
                        />
                    </span>
                    <span v-else>
                      <img v-if="menu.custom_small_take_out_icon" class="h-9 p-1 ml-1" :src="menu.custom_small_take_out_icon" alt="Take Away"/>
                      <IconHome v-else
                        classes="h-9 p-1"
                        :stroke="smallOrderTypeIconColor"/>
                    </span>
                      <p
                        class="ml-4 text-new-primary font-bold pr-6"
                        :style="menu.layout == 'frydate' ? btnSecondText : btnThirdText"
                      >
                        <span v-if="!hasKiosk && currentOption">
                          {{ lang[currentOption][language] }}</span
                        >
                        <span v-else>{{ currentKioskMode }}</span>
                      </p>
                    </a>
                  </div>
                </div>
                <div
                  :class="['flex pl-4 pr-4 h-full', this.$route.name == 'OrderDetails' ? 'w-full' : '']"
                  v-if="this.$route.params.menuHash != 'L'"
                  @contextmenu="forceHardReload($route.params.menuHash)"
                  data-force-reload
                >
                  <div
                    :class="[
                      'flex w-full h-full',
                      this.$route.name !== 'Home'
                        ? 'justify-center'
                        : 'self-center',
                    ]"
                  >
                    <!-- show qr code app logo if user did not select logo -->
                    <div
                      class="flex flex-row justify-center pr-4 w-32"
                      v-if="this.$route.name == 'Home'"
                    >
                      <img
                        class="h-24 rounded-md object-contain"
                        :src="
                          menu.picture_url
                            ? menu.picture_url
                            : require('./assets/images/Menu.Logo.png')
                        "
                        alt="Logo"
                        :style="isMobileDevice ? '' : headerLogoHeight"
                      />
                    </div>
                    <!-- lennert qr title -->
                    <!-- tile and description  -->
                    <div class="self-center h-full">
                      <!-- titel display but also menu app logo? -->
                      <div :class="['flex flex-col w-full h-full']">
                        <p
                          class="'justify-center flex text-white text-xl"
                          :style="makeStyles(headerMainText,hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                          v-if="this.$route.name == 'Home'"
                        >
                          {{ menu["name" + "_" + language] }}
                        </p>
                        <div
                          class="flex flex-col justify-center items-center text-white text-xl h-full"
                          :style="headerMainText"
                          v-if="this.$route.name != 'Home'"
                        >
                          <img
                            :class="[
                              'rounded-md object-contain'
                            ]"

                            :src="menu.picture_url"
                            v-if="menu.picture_url"
                            alt="Logo"
                            style="max-height:75%;max-width: 65%;"
                          />
                          <p
                          v-if="menu.show_title_in_header || !menu.picture_url"
                          class="text-center text-xs md:text-md"
                          :style="makeStyles(hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                          >{{ menu["name" + "_" + language] }}</p>
                        </div>
                        <p
                          v-if="this.$route.name == 'Home'"
                          class="'justify-center flex text-white text-sm"
                          :style="headerMainText"
                        >
                          {{ menu["description" + "_" + language] }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-1/6 flex justify-end items-center text-white self-center"
                    v-if="this.$route.name == 'Home' && (isTablesLoading || stickerId > 0)"
                  >
                    <ClipLoader size="30px" v-if="isTablesLoading"/>
                    <p v-else-if="stickerId>0" class="text-2xl -mt-1">{{ stickerId }}</p>
                  </div>
                </div>
                <div
                  v-if="menu.enable_delivery && this.$route.name == 'Home'||
                    (hasKiosk&& landingsPageDelivery && this.$route.name == 'Home')
                  "
                  class="flex justify-between"
                >
                  <div v-if="hasKiosk" class="mt-4 mb-6 w-auto inline-block pl-4">
                    <a
                      @click="
                        hasKiosk
                          ? $router.push({ path: `/${menuHash}/start/kiosk` ,query:$route.query})
                          : $router.push({
                              path: `/${menuHash}/delivery/take-out`,
                            })
                      "
                      class="rounded-xxl flex items-center justify-center"
                      :style="makeStyles(hasKiosk&&languageButtonRadius,'border-radius:0px',btnThirdBackground)"
                    >
                    <IconTruck
                        v-if="currentKioskMode == lang['take_away'][language]"/>
                      <IconHome v-else 
                      stroke="#9D9D9D"
                      />
                      <p class="ml-2 text-new-primary font-bold">
                        <span class="pr-4" v-if="!hasKiosk && currentOption">
                          {{ lang[currentOption][language] }}</span
                        >
                        <span v-else>{{ currentKioskMode }}</span>
                      </p>
                    </a>
                  </div>
                  <div v-else class="mt-4 mb-6 w-auto inline-block pl-4">
                    <a
                      v-if="!menu.is_disable_takeaway_w_deliv"
                      @click="
                        !landingsPageDelivery
                          ? hasKiosk
                            ? $router.push({ path: `/${menuHash}/start/kiosk` ,query:$route.query})
                            : $router.push({
                                path: `/${menuHash}/delivery/take-out`,
                              })
                          : ''
                      "
                      :href="
                        landingsPageDelivery
                          ? `https://m.qr-menu.app/L/${landingsPageDelivery}`
                          : null
                      "
                      class="rounded-xxl flex items-center justify-center"
                      :style="btnThirdBackground"
                    >
                      <IconBackArrow
                        v-if="landingsPageDelivery"
                        class="ml-2"
                          :fill="buttonImgColors"
                      />
                      <IconTruck
                        v-else-if="
                          currentKioskMode == lang['take_away'][language]"
                          />
                      <IconHome v-else 
                      stroke="#9D9D9D"
                      />
                      <p
                        v-if="!landingsPageDelivery"
                        class="ml-2 text-new-primary font-bold"
                      >
                        <span class="pr-4" v-if="!hasKiosk && currentOption">
                          {{ lang[currentOption][language] }}</span
                        >
                        <span v-else>{{ currentKioskMode }}</span>
                      </p>
                      <p class="pr-4" v-else>
                        {{ lang["go_back"][this.language] }}
                      </p>
                    </a>
                  </div>
                </div>
                
                <div v-if="(!menu.enable_delivery && !landingsPageDelivery ||!menu.enable_delivery)|| ['Category','CategoryCategory'].includes(this.$route.name)" class="flex items-center absolute right-0">
                  <LanguageModal />
                  <InfoModal v-if="menu.info_modal_properties && menu.info_modal_properties.is_enabled" />
                </div>
                <div class="flex items-center absolute right-0">
                  <LanguageModal />
                  <InfoModal v-if="menu.info_modal_properties && menu.info_modal_properties.is_enabled" />
                </div>
              </div>
              <router-view />
            </div>
          </div>
          <!-- Show the field to put in a code if there is no hash -->
          <div v-else>
            <div
              id="menu"
              class="mx-auto"
              :class="[hasKiosk?'h-screen':'h-full']"
              key="content"
              :style="backgroundMain"
            >
              <div class="flex flex-wrap text-center justify-center">
                <div class="w-full">
                  <div class="flex items-center justify-center flex-col py-6">
                    <img
                      class="h-32"
                      :src="
                        menu.picture_url
                          ? menu.picture_url
                          : require('./assets/images/Menu.Logo.png')
                      "
                      alt="Logo"
                    />
                  </div>
                  <div>
                    <h2 class="text-2xl font-semibold text-gray-600"
                    :style="titleFont"
                    >
                      {{ menu["name" + "_" + language] }}
                    </h2>
                    <p class="text-lg leading-relaxed mb-4 text-gray-500">
                      {{ menu["description" + "_" + language] }}
                    </p>
                  </div>
                  <p class="text-white font-semibold">QR MENU APP</p>
                  <div class="flex justify-center flex-col items-center">
                    <input
                      @keyup.enter="submitUserProvidedMenuHash()"
                      v-model="userProvidedMenuHash"
                      class="border-2 text-center outline-none focus:outline-none focus:border-new-primary rounded-lg py-2 px-4 mt-8 block w-half appearance-none leading-normal mb-4 transition duration-500"
                      type="text"
                      placeholder="Eg., 192PEFM"
                    />
                    <span class="text-red-300">{{ errorMessage }}</span>
                    <button
                      @click="submitUserProvidedMenuHash()"
                      :class="[
                        'bg-primary-100 mt-6 text-new-primary px-12 outline-none w-1/3 font-bold py-2 rounded-large items-center transition duration-500 flex justify-center',
                      ]"
                    >
                      Enter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            this.$route.name !== 'Home' && this.$route.name !== 'DeliveryStart'
          "
        >
          <transition tag="ul" name="slide">
          <div
            @click="
              !hasKiosk
                ? (!menu.is_cups_enabled && menu.cups_product_id == 0) ||
                  (!hasKiosk&&
                    menu.is_cups_enabled &&
                    menu.cups_product_id == 0)
                  ? $modal.show('cart-items')
                  : $modal.show('cups')
                : '';
              menu.is_cups_enabled && menu.cups_product_id != 0
                ? getCupItem()
                : '';
            "
            :class="[
              'md:block cartKioskBtn fixed bottom-0 w-full md:w-11/12 rounded-t-xxl',
              hasKiosk ? 'pb-8 pt-6' : desktopMode ? 'py-5' : 'py-6',
            ]"
            v-if="
              cartItems.length > 0 &&
              this.$route.name != 'OrderDetails' &&
              this.$route.name != 'KioskStart'
            "
              :style="makeStyles(hasKiosk&& cartSectionTopRadius ,desktopMode&&!hasKiosk ? '' : paymentFloatBackground) + staticVerticalMenuStyles"
          >
              <div :class="[desktopMode&&!hasKiosk && 'flex']">
              <div
                :class="['flex overflow-scroll pt-5 pl-6 mb-6',
                    hasKiosk&& 'mb-6',
                    menu.layout == 'frydate' ? 'font-sans' : ''
                ]"
                v-if="hasKiosk">
                <div
                  v-for="({ cartItem, amount }, index) in 
                  hasKiosk?
                  collectedCartItems:
                  desktopMode
                      ? collectedCartItems.slice(0, 3)
                      : collectedCartItems
                  "
                  :key="index"
                >
                  <div
                    :class="[
                      'mr-6 flex relative rounded-xl CartItem--shadow mb-3 max-w-300px',
                    ]"
                    :style="makeStyles(kioskLastItemBackgroundColor,cartItemRadius)"
                  >
                    <div class="w-24 h-24 flex-shrink-0">
                      <Picture
                        v-if="cartItem.pictureUrl"
                        :src="cartItem.pictureUrl"
                        class="w-full h-full rounded-l-xl"
                        alt
                        keep-ratio
                      />
                    </div>
                    <div class="px-4 my-3 flex flex-col justify-center">
                      <h2
                        class="font-medium CartItem__title flex-shrink-0 text-gray-800 text-lg"
                        :style="kioskLastItemTitle"
                      >
                        {{ cartItem[`name_${language}`] }}
                      </h2>
                      <div class="opacity-70">
                        <small :style="kioskLastItemPrice" class="mr-2 text-xs"
                          >x{{ amount }}</small
                        >
                        <span
                          :class="['font-bold text-xs', 'text-new-primary ']"
                          :style="kioskLastItemPrice"
                          v-currency="calculateTotalAmount(cartItem)"
                        >
                        </span>
                      </div>
                    </div>
                    <div class="kioskDeleteItem"
                      v-if="cartItem.is_removable"
                    >
                      <button 
                      class="w-full h-full "
                      @click.prevent="deleteItem(cartItem)">
                        <IconCancel
                          classes="fill-current inline-block p-2 rounded-full cursor-pointer"
                            :fill="btnDestructiveIcon"
                            :stroke="btnDestructiveIcon"
                            :style="deleteIconKioskBackground"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="[
              'flex items-center',
              hasKiosk&&desktopMode ? 'mx-6' : 'px-10'
              ]">
                <div :class="['mr-8', menu.layout == 'frydate' ? 'font-sans' : '']" v-if="hasKiosk">
                  <p
                    class="text-lg font-semibold lowercase -mb-1"
                    :style="kioskTotalColor"
                  >
                    {{ lang["total"][language] }}
                  </p>
                  <span
                    class="font-bold text-2xl"
                    v-currency="totalPriceValueWithCosts"
                    :style="kioskTotalPrice"
                  ></span>
                </div>
                <div
                  :class="['text-center rounded-full text-xl px-12 whitespace-no-wrap font-medium py-4',
                  menu.layout == 'frydate' ? 'uppercase' : '']"
                  v-if="hasKiosk"
                  :style="makeStyles(hasKiosk&&secondButtonRadius, kioskCancelButtonBackground, kioskCancelButtonColor)"
                  @click="$modal.show('cancelPermission')"
                >
                  <p>{{ lang["cancel_order"][language] }}</p>
                </div>
                <div
                  @click="
                    hasKiosk
                      ? $modal.show('cart-items')
                      : '',
                      updateCartProcess()
                  "
                    id="_cart-id"
                  :class="[
                    'bg-new-primary text-white text-center mx-auto rounded-full cursor-pointer flex items-center justify-center',
                    hasKiosk ? 'ml-4 py-4' : 'py-2',
                    !desktopMode && 'w-10/12',
                    desktopMode && 'px-10 py-3 text-xl fixedDesktopCart',
                    menu.layout == 'frydate' ? 'uppercase' : '',
                  ]"
                  :style="makeStyles(hasKiosk&&mainButtonRadius,proceedBtnBackground,kioskPaymentButtonColor)"
                >
                  <img
                    v-for="paymentTypes in availablePaymentTypes.filter(
                      (type) => type.has_priority
                    )"
                    :key="paymentTypes.Id"
                    class="h-8 rounded-md object-contain mr-2"
                    :src="require('./assets/images/payconiq-logo.png')"
                    alt="Logo"
                  />
                  <p
                    v-if="!hasKiosk"
                    :class="[
                    !hasKiosk ? 'whitespace-no-wrap font-normal' : 'font-bold',
                    !hasKiosk&&!desktopMode?'text-sm':'text-xl'
                    ]"
                  >
                    {{ hasKiosk?
                        lang["payment"][language]:
                        lang[desktopMode ? "go_to_cart" : "payment"][language]
                      }}
                    <span v-currency="totalPriceValueWithCosts"
                        :class="[desktopMode && 'ml-10']"
                        />
                  </p>
                  <p
                    v-else
                    :class="[hasKiosk && 'text-xl font-medium tracking-wide',
                    ]"
                    :style="makeStyles(paymentBtnText)"
                  >
                    {{ lang["view_order"][language] }}
                  </p>
                </div>
                
              </div>
            </div>
            </div>
          </transition>
        </div>
        <cart-items-modal
        @before-open="openingModal"
        />
        <modal
          name="upselling-items"
          width="90%"
          height="90%"
          scrollable
          @closed="removeUpselling"
          @before-open="openingUpsellModal"
          class="roundedmodal relative"
        >
          <div
            :class="[
              'w-full rounded-full',
              hasKiosk ? 'h-10 pr-4 pt-2' : 'flex justify-end self-center items-center pr-6 pt-6',
            ]"
          >
          <a
          @click="$modal.hide('upselling-items')"
              :class="[
                'rounded-full cursor-pointer bg-background-red h-8 w-8 flex justify-center items-center',
                hasKiosk ? 'deleteButtonRight' : '',
              ]"
              :style="btnDestructiveBackground"
            >
              <svg
                :class="[
                  'fill-current inline-block h-6 w-6 rounded-full cursor-pointer',
                ]"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                :stroke="currentColor"
                :style="btnDestructiveText"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </a>
          </div>
          <div v-if="hasKiosk">
            <SubCategory 
            :isUpselling="isUpselling" />
          </div>
          <div v-else>
            <SubCategory
              v-for="(upselling, index) in modifiedUpsellings"
              :key="index"
              :upselling-prop="upselling"
              :isUpselling="isUpselling"
            />
          </div>

          <div class="sticky bottom-0 p-6 mt-6 FloatingButton__backdrop">
            <button
              :style="goBackButton + goBackButtonText"
              @click="$modal.hide('upselling-items')"
              :class="[
                'flex justify-center items-center rounded-full h-12 w-1/2 mx-auto font-bold text-xl cursor-pointer',
              ]"
            >
                {{ selectedUpsellItems.length > 0 ? lang["add_to_cart"][language] : lang["no_thanks"][language] }}
            </button>
          </div>
        </modal>
          <cups-modal
          :cups-item="cupsItem"
          :itemBeingAdded="itemBeingAdded"
          :disableAddButton="disableAddButton"
          />
        <modal
          name="retry-payment"
          width="90%"
          height="auto"
          :adaptive="true"
          scrollable
          :clickToClose="false"
        >
          <div class="mt-4">
            <div v-if="this.menu.pos_mode == 'table-manual'">
              <TableManual />
            </div>
            <div :class="this.menu.pos_mode == 'table-manual' ? '-mt-8' : ''">
              <Payment
                :class="
                  this.menu.pos_mode == 'table-manual' && !this.tableManual
                    ? 'hidden'
                    : 'block'
                "
              />
              <button
                @click="createNewOrder()"
                type="button"
                :class="[
                  ' text-sm mb-4 -mt-4 p-4 flex just mx-auto py-2 font-semibold transition duration-300 rounded-large border bg-new-primary text-white',
                ]"
                :style="makeStyles(hasKiosk && mainButtonRadius , btnMainBackground , btnMainText)"
              >
                {{ lang["create_new_order"][language] }}
              </button>
            </div>
          </div>
        </modal>
        <modal
          name="cancelPermission"
          class="roundedmodal"
          width="90%"
          :maxWidth="750"
          height="auto"
          :adaptive="true"
          scrollable
        >
          <div class="mt-3 flex justify-end pr-3">
            <a @click.prevent="$modal.hide('cancelPermission')">
              <IconCancel
                :fill="btnDestructiveIcon"
                :stroke="btnDestructiveIcon"
                :style="deleteIconKioskBackground"
              />
            </a>
          </div>
          <div class="pl-8 pr-8 pb-8">
            <div>
              <h3 class="text-center text-4xl font-bold">
                {{ lang["are_you_sure_cancel"][this.language] }}
              </h3>
            </div>
            <div class="flex justify-center mt-6">
              <Button
                @click="cancelOrder"
                class="bg-red-600 text-white mr-6 whitespace-no-wrap text-xl"
                :style="makeStyles(hasKiosk&&mainButtonRadius)"
              >
                {{ lang["cancel_order"][language] }}</Button
              >
              <Button
                @click="$modal.hide('cancelPermission')"
                class="bg-blue-600 text-white whitespace-no-wrap text-xl"
                :style="makeStyles(hasKiosk&&mainButtonRadius)"
              >
                {{ lang["continue_order"][language] }}</Button
              >
            </div>
          </div>
        </modal>
        <transition name="slide-fade">
          <modal
            name="orderType"
            class="roundedmodal"
            transition="slide-fade"
            width="90%"
            :maxWidth="680"
            height="auto"
            :adaptive="true"
            scrollable
          >
            <div class="mt-3 flex justify-end pr-3">
              <a @click.prevent="$modal.hide('orderType')">
                <IconCancel
                  :fill="btnDestructiveIcon"
                  :stroke="btnDestructiveIcon"
                  :style="deleteIconKioskBackground"
                />
              </a>
            </div>
            <div class="pl-8 pr-8 pb-8">
              <div class="flex justify-center">
                <button
                  v-for="(type, i) in orderTypes"
                  :key="i"
                  v-if="type == 'take_away' ? menu.is_kiosk_take_away_enabled : menu.is_kiosk_dine_in_enabled"
                  @click="setOrderType(type)"
                  :class="[
                    'bg-primary-100 w-64 text-new-primary font-bold text-center text-3xl flex flex-col justify-center items-center rounded-xl',
                    orderTypes.length - 1 !== i && 'mr-8',
                    menu.hide_kiosk_icon_text?'py-20':'py-24'
                  ]"
                  :style="makeStyles( kioskLandingPageCardRadius, titleFont , titleTextTransform, kioskStartBackgroundButton , textKioskHomepageColor)"
                >
                  <OrderTypeIcons
                    :type="type"
                    class="mb-4"
                    :color="iconKioskHomepageColor"
                    :size="imageWidth"
                  />
                  <template v-if="!menu.hide_kiosk_icon_text&&lang[type]">
                    {{ lang[type][language] }}
                  </template>
                  <template v-else-if="!menu.hide_kiosk_icon_text">
                    {{ type }}
                  </template>
                </button>
              </div>
            </div>
          </modal>
        </transition>
      </div>
      <div
        :class="[
          !isThemeLoading && 'hidden',
          'h-screen flex items-center justify-center',
        ]"
      >
        <ClipLoader color="black" />
      </div>
    </div>
    <TimeOutModal />
    <KioskScreensaver
      :src="this.menu.screensaver_url"
      type="video"
      v-if="this.$route.name === 'KioskStart' && cartItems.length === 0"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import lang from "./lang.js";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import _ from "lodash";

import Header from "./components/Header";
import LanguageModal from "./components/LanguageModal";
import TimeOutModal from "./components/TimeOutModal.vue";
import KioskScreensaver from "./components/KioskScreensaver.vue";
import SubCategory from "./views/SubCategory.vue";
import Payment from "./views/Payment";
import TableManual from "./views/TableManual.vue";
import Button from "./components/Button.vue";

import {
  disableContextClick,
  forceHardReload,
  // saveNewSessionId,
  sortCartByAdditions,
} from "./utils";
import IconBackArrow from "./components/icons/iconBackArrow.vue";
import IconCancel from "./components/icons/iconCancel.vue";
import IconHome from "./components/icons/iconHome.vue";
import IconTruck from "./components/icons/iconTruck.vue";
import CartItemsModal from './components/cartItemsModal.vue'
import CupsModal from "./components/CupsModal.vue";
import OrderTypeIcons from "./components/OrderTypeIcons.vue";
import InfoModal from "./components/InfoModal.vue";

const orderTypes = ["dine_in", "take_away"];
export default {
  name:"App",
  components: {
    Header,
    LanguageModal,
    ClipLoader,
    SubCategory,
    Payment,
    TableManual,
    TimeOutModal,
    KioskScreensaver,
    Button,
    IconBackArrow,
    IconCancel,
    IconHome,
    IconTruck,
    CartItemsModal,
    CupsModal,
    OrderTypeIcons,
    InfoModal
},
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("contextmenu", disableContextClick);
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      imageWidth: 0,
      infiniteScroll: true,
      userProvidedMenuHash: "",
      errorMessage: "",
      lang: lang,
      // stickerId: localStorage.getItem("stickerId") || "",
      // tableId: "",
      currentOption: "",
      isChrome: false,
      firstUpdate: false,
      cupsItem: [],
      disableAddButton: false,
      itemBeingAdded: "",
      additionPrice: [],
      filteredAdditionPrice: null,
      hotelParams: ["fullName", "email", "roomNumber", "lastName", "phone"],
      orderTypes,
    };
  },
  computed: {
    ...mapGetters([
      "isSearchKiosk",
      "selectedMenuCategory",
      "menuCategories",
      "language",
      "menuHash",
      "hasKiosk",
      "menu",
      "theme",
      "orderingEnabled",
      "isCartViewShown",
      "isMobileDevice",
      "isSwipeOpen",
      "floatButtonLabel",
      "processStack",
      "buttonStack",
      "processBarIndex",
      "showTable",
      "showPayment",
      "showForm",
      "showTableManual",
      "processCurrentName",
      "processBarCurrentItem",
      "isSafari",
      "isDelivery",
      "currentKioskMode",
      "orderStatus",
      "upselling",
      "selectedMenuCategory",
      "currency",
      "idleTimer",
      "routeName",
      "userAgent",
      "desktopMode",
      "landingsPageDelivery",
      "isUpselling",
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "totalPriceValueWithCosts",
      "homeDelivery",
      "tableManual",
      "items",
      "availablePaymentTypes",
      "isTablesLoading",
      "tables",
      "showUpselling",
      "homeDelivery",
      "tableId",
      "stickerId",
      "selectedUpsellItems",
    ]),
    ...mapGetters("Theme", [
      "cartItemRadius",
      "languageButtonRadius",
      "cartSectionTopRadius",
      "deleteIconKioskBackground",
      "iconKioskHomepageColor",
      "backgroundMain",
      "btnThirdBackground",
      "btnThirdText",
      "btnSecondText",
      "paymentBtnBackground",
      "paymentFloatBackground",
      "selectedTheme",
      "buttonImgColors",
      "cardSecondaryBackground",
      "headerMainText",
      "kioskArrowBackground",
      "kioskArrow",
      "btnDestructiveIcon",
      "text",
      "titleFont",
      "titleTextTransform",
      "kioskLastItemBackgroundColor",
      "kioskLastItemTitle",
      "kioskLastItemPrice",
      "btnDestructiveBackground",
      "btnDestructiveText",
      "QrMenuAppTitle",
      "btnMainBackground",
      "mainButtonRadius",
      "mainSectionTopRadius",
      "btnMainText",
      "landingsPageSelectionBackgroundUrl",
      "changeFont",
      "currentColor",
      "goBackButtonText",
      "goBackButton",
      "kioskTotalPrice",
      "kioskTotalColor",
      "kioskCancelButtonBackground",
      "secondButtonRadius",
      "kioskCancelButtonColor",
      "kioskPaymentButtonColor",
      "textKioskHomepageColor",
      "kioskLandingPageCardRadius",
      "kioskStartBackgroundButton",
      "leftCategoryNavigationBackground",
      "cartHeaderHeight",
      "headerLogoHeight",
      "orderTypeIconSize",
      "proceedBtnBackground",
      "smallOrderTypeIconColor",
      "backgroundMainFullImage",
      "paymentBtnText",
      "isStaticSideMenu",
      "headerButtonBackground"
    ]),
    staticVerticalMenuStyles() {
      if (this.hasKiosk && this.isStaticSideMenu) {
        return 'left:unset; right: 4rem; width:68%; overflow:hidden';
      }
      return '';
    },
    isThemeLoading: {
      set(value) {
        this.$store.commit('updateIsThemeLoading', value);
      },
      get() {
        return this.$store.getters.isThemeLoading;
      }
    },
    modifiedUpsellings() {
      var modifiedUpsellings = [];
      var index = -1;
      this.upselling.forEach((item) => {
        if (item?.upselling_custom_group_name || item?.upsell_item_available) {
          index++;
          modifiedUpsellings[index] = {};
          modifiedUpsellings[index].upselling_custom_group_name =
            item.upselling_custom_group_name;
          modifiedUpsellings[index].data = [];
        }
        modifiedUpsellings[index]?.data.push(item);
      });
      return modifiedUpsellings;
    },
    /**
     * Based on the selected language, the link color would be changed.
     */
    selectedLanguageColor() {
      if (this.language == "en") {
        return "text-primary";
      }
      return "text-gray-500";
    },
    collectedCartItems() {
      const items = this.cartItems;
      const result = sortCartByAdditions(items);
      return result;
    },
  },
  methods: {
    // take_away || dine_in
    setOrderType(type) {
      // get the category of first menu item(which can be shown in the selected orer type) when the selected menu category is not to be shown in the selected order type 
      if (this.hasKiosk && !this.isMobileDevice) {
        if ((type == "dine_in" && this.selectedMenuCategory.is_dine_in == 0) || (type == "take_away" && this.selectedMenuCategory.is_take_out == 0)) {
          let index;
          if(type == "dine_in") {
            index = this.menuCategories.findIndex(el => el.is_dine_in == 1)
          }
          else if(type == "take_away") {
            index = this.menuCategories.findIndex(el => el.is_take_out == 1)
          }
          this.getCategories(this.menuCategories[index]);
        }
      }
      this.$modal.hide("orderType");
      if (type === "take_away") this.$store.commit("Cart/updateHomeDelivery");
        this.$store.commit("updateCurrentKioskMode", lang[type][this.language]),
        this.$store.commit("updateCancelOrder", false);
      this.$store.commit("Cart/updateIsOrderTypeDineIn", type === "dine_in");
      this.addLocalstorage(lang[type]);
    },
    // get the menu categories and push the router to the correct path
    getCategories(item) {
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);
        
        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
          .catch(() => {});
      } else {
        this.$store.dispatch("GET_CATEGORY");
        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
          .catch(() => {});
      }
    },
    addLocalstorage(value) {
      localStorage.setItem("kioskOption", value[this.language]);
    },
    calculateTotalAmount(item) {
      let totalPrince = item.price;
      return (totalPrince += item.OrderItemAdditions.reduce((acc, cur) => {
        return (acc += cur.Addition.price);
      }, 0));
    },
    /**
     * Checking visibility of the language change link.
     *
     * @param key string
     * @param language string
     *
     * @returns Bool
     */
    cancelOrder() {
      this.$store.commit("updateSearchItemInput", "")
      this.$store.commit("updateIsSearchKiosk",false)
      this.$modal.hide("cancelPermission");
      this.$store.commit("updateCancelOrder", true);
      this.$store.commit("Cart/emptyCart");
      this.$store.commit("updateMember", "");
      this.$router.push({ path: "/" + this.menuHash + "/start/kiosk" ,query:this.$route.query});
    },
    correctItemPrice() {
      if (this.cartItems) {
        let additionItemPrice = 0;
        let object = {};
        this.cartItems.map((item) => {
          additionItemPrice = 0;
          if (item.OrderItemAdditions) {
            if (item.OrderItemAdditions.length == 0) {
              object = {
                id: item.Id,
                price: 0,
              };
              this.additionPrice.push(object);
            }
            item.OrderItemAdditions.map((y) => {
              additionItemPrice += y.Addition.price;
              object = {
                id: item.Id,
                price: additionItemPrice,
              };
            });
            this.additionPrice.push(object);
            this.filteredAdditionPrice = _.uniqWith(
              this.additionPrice,
              _.isEqual
            );
          } else {
            object = {
              id: item.Id,
              price: 0,
            };
            this.additionPrice.push(object);
          }
        });
      }
    },
    getCupItem() {
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_PATH}/GetMenuItemOrdering?MenuHash=${this.menuHash}&MenuItemId=${this.menu.cups_product_id}`
        )
        .then((response) => {
          this.cupsItem = response.data.MenuItem;
        });
    },
    addToCart(item) {
      this.$store.commit("Cart/updateOrderItemCount", 1);
      if (!this.disableAddButton) {
        this.disableAddButton = true;
        if (
          this.orderingEnabled &&
          this.selectedMenuCategory.is_ordering_disabled == false
        ) {
          this.currentItem = item;
          this.$store.commit("updateCategoryId", item.MenuCategoryId);
          this.itemBeingAdded = this.currentItem.Id;
          this.$store
            .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
            .then((response) => {
              this.itemBeingAdded = null;
              if (response.data.Modifiers.length) {
                this.modifiers = response.data.Modifiers;
                this.$modal.show("item-modifiers");
              } else {
                this.$store.dispatch("Cart/UPDATE_ORDER", {
                  operation: "add",
                  item: this.currentItem,
                });
              }

            })
            .catch(() => {
              this.itemBeingAdded = null;
            }).finally(() => {
              setTimeout(() => (this.disableAddButton = false), 150);
            });
        }
      }
    },
    removeFromCart(item) {
      this.additionPrice = [];
      this.filteredAdditionPrice = null;
      this.deleteCorrectitem = [];
      this.allChosenItems = [];
      for (let i = 0; i < this.cartItems.length; i++) {
        if (item.Id == this.cartItems[i].Id) {
          this.allChosenItems.push(this.cartItems[i]);
        }
      }
      this.deleteCorrectitem.push(_.uniqWith(this.allChosenItems, _.isEqual));
      if (this.deleteCorrectitem[0].length != 1) {
        this.$modal.show("deleteItem");
      } else {
        if (!this.disableAddButton) {
          this.disableAddButton = true;
          this.currentItem = item;
          this.itemBeingAdded = this.currentItem.Id;

          /**
           * Sanitising the item before sending to the store for the removal. (Related to Upsale)
           * Upsaling adds few other key-values to the items. (Removing that.)
           */
          this.$store
            .dispatch("Cart/UPDATE_ORDER", {
              operation: "remove",
              item: this.$_.omit(item, [
                "upsell_item_available",
                "upselling_custom_group_name",
              ]),
            })
            .then(() => {
              this.itemBeingAdded = null;
            })
            .catch(() => {
              this.itemBeingAdded = null;
            }).finally(() => {
              setTimeout(() => (this.disableAddButton = false), 150);
            });
        }
      }
      if(this.hasKiosk){
        this.correctItemPrice();
      }
    },
    removeUpselling() {
      this.$store.commit("selectedUpsellItems",[])  
      this.$store.commit("Cart/updateUpsaleGroups", []);
      // this.isUpselling = false; 
      this.$store.commit("setIsUpselling", false);
      this.$store.commit("Cart/updateIsCartOverviewShow", false);
      this.$store.commit("Cart/updateShowUpselling", false);
      this.$store.commit("removeupsellingItems");
      if(this.hasKiosk){
        if (document.getElementsByClassName("prev")[0]) {
          document.getElementsByClassName("prev")[0].style.display = "flex";
          document.getElementsByClassName("next")[0].style.display = "flex";
        }
      }
    },
    openingModal() {
      this.$store.commit("Cart/updateIsCartOverviewShow", true);
      if(this.hasKiosk){
          if (document.getElementsByClassName("prev")[0]) {
          document.getElementsByClassName("prev")[0].style.display = "none";
          document.getElementsByClassName("next")[0].style.display = "none";
          }
      }
    },
    openingUpsellModal() {
      this.$store.commit("setIsUpselling", true);
      this.$store.commit("Cart/updateIsCartOverviewShow", true);
      if(this.hasKiosk){
          if (document.getElementsByClassName("prev")[0]) {
          document.getElementsByClassName("prev")[0].style.display = "none";
          document.getElementsByClassName("next")[0].style.display = "none";
          }
      }
    },

    removeItem(item) {
      if (!this.disableAddButton) {
        this.disableAddButton = true;
        this.additionPrice = [];
        this.filteredAdditionPrice = null;
        this.$store
          .dispatch("Cart/UPDATE_ORDER", { operation: "remove", item: item })
          .then(() => {
            // setTimeout(() => (this.disableAddButton = false), 150);
          })
          .catch((err) => { 
            // eslint-disable-next-line
            console.error(err);
          })
          .finally(() => {
            setTimeout(() => (this.disableAddButton = false), 150);
          })
        this.correctItemPrice();
        this.$store.commit("updateIsSwipeOpen", false);
      }
    },
    deleteItem(item) {
      if (!this.disableAddButton) {
        this.disableAddButton = true;
        this.additionPrice = [];
        this.filteredAdditionPrice = null;
        this.$store
          .dispatch("Cart/UPDATE_ORDER", { operation: "delete", item: item })
          .then(() => {
            // setTimeout(() => (this.disableAddButton = false), 150);
          })
          .catch((err) => { 
            // eslint-disable-next-line
            console.error(err);
          })
          .finally(() => {
            setTimeout(() => (this.disableAddButton = false), 150);
          })
        this.correctItemPrice();
        this.$store.commit("updateIsSwipeOpen", false);
      }
    },
    languageVisibility(key, language) {
      /** Making sure the default language is always visible. */
      if (this.menu.language == language) {
        return true;
      }
      /** Language availablity based on the value present on the
       * menu object on the vuex store.
       */
      return this.menu[key];
    },
    submitUserProvidedMenuHash() {
      if (!this.userProvidedMenuHash) {
        // eslint-disable-next-line
        return console.error("menu hash should not be blank");  
      }
      this.isThemeLoading = true;
      this.$router.push({ path: "/" + this.userProvidedMenuHash ,query:this.$route.query}).catch(() => {});
      this.$store.commit("updateMenuHash", this.userProvidedMenuHash);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width >= 777) {
        this.$store.commit("updateIsMobileDevice", false);
      } else {
        this.$store.commit("updateIsMobileDevice", true);
      }
    },
    createNewOrder() {
      this.$store.commit("Cart/removeOrderChunks");
      // saveNewSessionId("createNewOrder");
      this.$store.dispatch("CREATE_NEW_SESSION_ID")
      if (this.menu.pos_mode == "take-out" && !this.hasKiosk) {
        location.href = `/${this.menuHash}`;
      } else if (this.hasKiosk) {
        if (this.$route.query.printerIp) {
          location.href = `/${this.menuHash}/start/kiosk?mode=kiosk&printerIp=${this.$route.query.printerIp}`;
        } else {
          location.href = `/${this.menuHash}/start/kiosk?mode=kiosk`;
        }
      } else {
        location.href = `/${this.menuHash}/${
          this.$route.params.tableId != "0" && this.$route.params.tableId != undefined
            ? this.$route.params.tableId
            : this.stickerId
        }`;
      }
    },
    updateCartProcess() {
      sessionStorage.setItem("orderChunksExists", true);
      this.$store.commit("updateProcessBarCurrentItem", 1);
      this.$store.commit("updateProcessBarIndex", 1);
      this.$store.commit("updateProcessCurrentName", "Category");
      this.$store.commit("updateShowPayment", false);
      this.$store.commit("updateShowForm", false);
      this.$store.commit("updateShowTable", false);
      this.$store.commit("updateShowTableManual", false);
      let path;
      let pointer;
      let onClickIndex;
      let routeName;
      let label;
      let processBarUpdate;
      switch (this.processCurrentName) {
        case "Category": {
          if (
            this.menu.timeslots_mode == "general" ||
            this.menu.timeslots_mode == "individual"
          ) {
            if (this.menu.pos_mode == "take-out") {
              this.$store.commit("updateProcessBarCurrentItem", 1);
              this.$store.commit("updateProcessBarIndex", 1);
              this.$store.commit(
                "updateFloatButtonLabel",
                lang["select_time_slot"][this.language]
              );
              this.$store.commit(
                "updateProcessCurrentName",
                "TimeSlotSelection"
              );
              this.$store.commit("updateProcessStack", "TimeSlotSelection");
            } else {
              if (
                this.menu.pos_mode == "table" ||
                this.menu.pos_mode == "table-manual"
              ) {
                if (
                  this.stickerId == 0 ||
                  this.stickerId == null ||
                  !this.tableId == null
                ) {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["select_table"][this.language]
                  );

                  this.$store.commit(
                    "updateProcessCurrentName",
                    "TableSelection"
                  );
                  this.$store.commit("updateProcessStack", "TableSelection");
                  if (this.menu.pos_mode == "table") {
                    this.$store.commit("updateShowTable", true);
                  } else {
                    this.$store.commit("updateShowTableManual", true);
                  }
                } else {
                  if (this.menu.customer_details_disabled == false && this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true) {
                    this.$store.commit(
                      "updateFloatButtonLabel",
                      lang["leave_contact_details"][this.language]
                    );
                    this.$store.commit(
                      "updateProcessCurrentName",
                      "UserDetails"
                    );
                    this.$store.commit("updateProcessStack", "UserDetails");
                  } else {
                    this.$store.commit(
                      "updateFloatButtonLabel",
                      lang["continue_to_payment"][this.language]
                    );
                    this.$store.commit("updateProcessCurrentName", "Payment");
                    this.$store.commit("updateProcessStack", "Payment");
                    this.$store.commit("updateShowPayment", true);
                  }
                }
              }
            }
          } else {
            if (this.menu.pos_mode == "take-out") {
              this.$store.commit("updateShowTable", false);
              this.$store.commit("updateShowTableManual", false);
              if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["leave_contact_details"][this.language]
                );
                this.$store.commit("updateProcessCurrentName", "UserDetails");
                this.$store.commit("updateProcessStack", "UserDetails");
              } else {
                if (
                (this.menu.timeslots_mode == "simple" ||
                  this.menu.timeslots_mode == "") && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)
                ) {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                } else {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                }
              }
            } else {
              if (this.stickerId == 0) {
                path = `/${this.menuHash}/cart/table-selection`;
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["select_table"][this.language]
                );
                this.$store.commit(
                  "updateProcessCurrentName",
                  "TableSelection"
                );
                this.$store.commit("updateProcessStack", "TableSelection");
                if (this.menu.pos_mode == "table") {
                  this.$store.commit("updateShowTable", true);
                } else {
                  this.$store.commit("updateShowTableManual", true);
                }
              } else {
                if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
                  path = `/${this.menuHash}/cart/user-details`;
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                  this.$store.commit("updateShowForm", true);
                } else {
                  path = `/${this.menuHash}/cart/payment`;
                  this.$store.commit("updateShowTable", false);
                  this.$store.commit("updateShowTableManual", false);
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );

                  this.$store.commit(
                    "updateButtonStack",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit("updateShowPayment", true);
                }
              }
            }
          }
          return {
            visibility: true,
            EnablePossible: pointer,
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: true,
            showItems: false,
            onClickIndex: onClickIndex,
            routeName: routeName,
            processBarUpdate: processBarUpdate,
          };
        }
      }
    },
    forceHardReload,
  },
  mounted() {
    this.$store.dispatch("GET_MENU_ITEMS").then(() => {
    /**
     * Avoid displaying context menu on long press (right-click) if not in dev env
     */
    window.addEventListener("contextmenu", disableContextClick);

    this.$store.commit("Theme/updateSelectedTheme", this.theme);
    /* check if the device you are using is on safari */
    let isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;
    this.$store.commit("updateIsSafari", isSafari);

    // if (!this.hasKiosk&&this.$route.query.mode) {
    //   this.$store.commit("updateIsKiosk", true);
    // }
    // else {
    //   this.$store.commit("updateIsKiosk", false);
    // }
    // const isThemeStored = window.localStorage.getItem("theme");
    // if (isThemeStored || !this.$route.params.menuHash)
    //   this.isThemeLoading = false;
    // else this.isThemeLoading = true;


    // if (localStorage.getItem("stickerId")) {
    //   return (this.stickerId = localStorage.getItem("stickerId"));
    // }
    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        /**
         * Any status code that lie within the range of 2xx cause this function to trigger
         * Do something with response data */
        return response;
      },
      (error) => {
        // To not to show the error dialog when user gets error while scanning QR code on KioskStart page to get loyalty como member details 
        if (error.response.config.url.includes("como/get-member-details")) {
          return Promise.reject(error);
        }
        if (["PickUpScreen"].includes(this.$route.name)) {
          return Promise.reject(error);
        }
        this.$modal.show("dialog", {
          title: this.lang["something_went_wrong"][this.language],
          text: error?.response?.data?.Errors?.join(","),
          buttons: [
            {
              title: this.lang["cancel"][this.language],
              handler: () => {
                this.$modal.hide("dialog");
              },
            },
            {
              title: this.lang["create_new_order"][this.language],
              handler: () => {
                sessionStorage.removeItem("orderChunksExists");
                // sessionStorage.setItem(
                //   "sessionId",
                //   [...Array(30)]
                //     .map(() => Math.random().toString(36)[2])
                //     .join("")
                // );
                // saveNewSessionId("App > mounted:2545");
                this.$store.dispatch("CREATE_NEW_SESSION_ID")

                location.href = `/${this.menuHash}/${localStorage.getItem(
                  "stickerId"
                )}`;
              },
            },
          ],
        });
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
      }
    );
    /** Apply Global Theme settings */
    if (this.theme.body.defaultBackgroundImage) {
      document.body.style.backgroundImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='260' viewBox='0 0 260 260'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23${this.theme.body.defaultBackgroundImageColor}' fill-opacity='0.4'%3E%3Cpath d='M24.37 16c.2.65.39 1.32.54 2H21.17l1.17 2.34.45.9-.24.11V28a5 5 0 0 1-2.23 8.94l-.02.06a8 8 0 0 1-7.75 6h-20a8 8 0 0 1-7.74-6l-.02-.06A5 5 0 0 1-17.45 28v-6.76l-.79-1.58-.44-.9.9-.44.63-.32H-20a23.01 23.01 0 0 1 44.37-2zm-36.82 2a1 1 0 0 0-.44.1l-3.1 1.56.89 1.79 1.31-.66a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .86.02l2.88-1.27a3 3 0 0 1 2.43 0l2.88 1.27a1 1 0 0 0 .85-.02l3.1-1.55-.89-1.79-1.42.71a3 3 0 0 1-2.56.06l-2.77-1.23a1 1 0 0 0-.4-.09h-.01a1 1 0 0 0-.4.09l-2.78 1.23a3 3 0 0 1-2.56-.06l-2.3-1.15a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1L.9 19.22a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01zm0-2h-4.9a21.01 21.01 0 0 1 39.61 0h-2.09l-.06-.13-.26.13h-32.31zm30.35 7.68l1.36-.68h1.3v2h-36v-1.15l.34-.17 1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0L2.26 23h2.59l1.36.68a3 3 0 0 0 2.56.06l1.67-.74h3.23l1.67.74a3 3 0 0 0 2.56-.06zM-13.82 27l16.37 4.91L18.93 27h-32.75zm-.63 2h.34l16.66 5 16.67-5h.33a3 3 0 1 1 0 6h-34a3 3 0 1 1 0-6zm1.35 8a6 6 0 0 0 5.65 4h20a6 6 0 0 0 5.66-4H-13.1z'/%3E%3Cpath id='path6_fill-copy' d='M284.37 16c.2.65.39 1.32.54 2H281.17l1.17 2.34.45.9-.24.11V28a5 5 0 0 1-2.23 8.94l-.02.06a8 8 0 0 1-7.75 6h-20a8 8 0 0 1-7.74-6l-.02-.06a5 5 0 0 1-2.24-8.94v-6.76l-.79-1.58-.44-.9.9-.44.63-.32H240a23.01 23.01 0 0 1 44.37-2zm-36.82 2a1 1 0 0 0-.44.1l-3.1 1.56.89 1.79 1.31-.66a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .86.02l2.88-1.27a3 3 0 0 1 2.43 0l2.88 1.27a1 1 0 0 0 .85-.02l3.1-1.55-.89-1.79-1.42.71a3 3 0 0 1-2.56.06l-2.77-1.23a1 1 0 0 0-.4-.09h-.01a1 1 0 0 0-.4.09l-2.78 1.23a3 3 0 0 1-2.56-.06l-2.3-1.15a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01zm0-2h-4.9a21.01 21.01 0 0 1 39.61 0h-2.09l-.06-.13-.26.13h-32.31zm30.35 7.68l1.36-.68h1.3v2h-36v-1.15l.34-.17 1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.56.06l1.67-.74h3.23l1.67.74a3 3 0 0 0 2.56-.06zM246.18 27l16.37 4.91L278.93 27h-32.75zm-.63 2h.34l16.66 5 16.67-5h.33a3 3 0 1 1 0 6h-34a3 3 0 1 1 0-6zm1.35 8a6 6 0 0 0 5.65 4h20a6 6 0 0 0 5.66-4H246.9z'/%3E%3Cpath d='M159.5 21.02A9 9 0 0 0 151 15h-42a9 9 0 0 0-8.5 6.02 6 6 0 0 0 .02 11.96A8.99 8.99 0 0 0 109 45h42a9 9 0 0 0 8.48-12.02 6 6 0 0 0 .02-11.96zM151 17h-42a7 7 0 0 0-6.33 4h54.66a7 7 0 0 0-6.33-4zm-9.34 26a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-4.34a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-4.34a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-7a7 7 0 1 1 0-14h42a7 7 0 1 1 0 14h-9.34zM109 27a9 9 0 0 0-7.48 4H101a4 4 0 1 1 0-8h58a4 4 0 0 1 0 8h-.52a9 9 0 0 0-7.48-4h-42z'/%3E%3Cpath d='M39 115a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm6-8a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-3-29v-2h8v-6H40a4 4 0 0 0-4 4v10H22l-1.33 4-.67 2h2.19L26 130h26l3.81-40H58l-.67-2L56 84H42v-6zm-4-4v10h2V74h8v-2h-8a2 2 0 0 0-2 2zm2 12h14.56l.67 2H22.77l.67-2H40zm13.8 4H24.2l3.62 38h22.36l3.62-38z'/%3E%3Cpath d='M129 92h-6v4h-6v4h-6v14h-3l.24 2 3.76 32h36l3.76-32 .24-2h-3v-14h-6v-4h-6v-4h-8zm18 22v-12h-4v4h3v8h1zm-3 0v-6h-4v6h4zm-6 6v-16h-4v19.17c1.6-.7 2.97-1.8 4-3.17zm-6 3.8V100h-4v23.8a10.04 10.04 0 0 0 4 0zm-6-.63V104h-4v16a10.04 10.04 0 0 0 4 3.17zm-6-9.17v-6h-4v6h4zm-6 0v-8h3v-4h-4v12h1zm27-12v-4h-4v4h3v4h1v-4zm-6 0v-8h-4v4h3v4h1zm-6-4v-4h-4v8h1v-4h3zm-6 4v-4h-4v8h1v-4h3zm7 24a12 12 0 0 0 11.83-10h7.92l-3.53 30h-32.44l-3.53-30h7.92A12 12 0 0 0 130 126z'/%3E%3Cpath d='M212 86v2h-4v-2h4zm4 0h-2v2h2v-2zm-20 0v.1a5 5 0 0 0-.56 9.65l.06.25 1.12 4.48a2 2 0 0 0 1.94 1.52h.01l7.02 24.55a2 2 0 0 0 1.92 1.45h4.98a2 2 0 0 0 1.92-1.45l7.02-24.55a2 2 0 0 0 1.95-1.52L224.5 96l.06-.25a5 5 0 0 0-.56-9.65V86a14 14 0 0 0-28 0zm4 0h6v2h-9a3 3 0 1 0 0 6H223a3 3 0 1 0 0-6H220v-2h2a12 12 0 1 0-24 0h2zm-1.44 14l-1-4h24.88l-1 4h-22.88zm8.95 26l-6.86-24h18.7l-6.86 24h-4.98zM150 242a22 22 0 1 0 0-44 22 22 0 0 0 0 44zm24-22a24 24 0 1 1-48 0 24 24 0 0 1 48 0zm-28.38 17.73l2.04-.87a6 6 0 0 1 4.68 0l2.04.87a2 2 0 0 0 2.5-.82l1.14-1.9a6 6 0 0 1 3.79-2.75l2.15-.5a2 2 0 0 0 1.54-2.12l-.19-2.2a6 6 0 0 1 1.45-4.46l1.45-1.67a2 2 0 0 0 0-2.62l-1.45-1.67a6 6 0 0 1-1.45-4.46l.2-2.2a2 2 0 0 0-1.55-2.13l-2.15-.5a6 6 0 0 1-3.8-2.75l-1.13-1.9a2 2 0 0 0-2.5-.8l-2.04.86a6 6 0 0 1-4.68 0l-2.04-.87a2 2 0 0 0-2.5.82l-1.14 1.9a6 6 0 0 1-3.79 2.75l-2.15.5a2 2 0 0 0-1.54 2.12l.19 2.2a6 6 0 0 1-1.45 4.46l-1.45 1.67a2 2 0 0 0 0 2.62l1.45 1.67a6 6 0 0 1 1.45 4.46l-.2 2.2a2 2 0 0 0 1.55 2.13l2.15.5a6 6 0 0 1 3.8 2.75l1.13 1.9a2 2 0 0 0 2.5.8zm2.82.97a4 4 0 0 1 3.12 0l2.04.87a4 4 0 0 0 4.99-1.62l1.14-1.9a4 4 0 0 1 2.53-1.84l2.15-.5a4 4 0 0 0 3.09-4.24l-.2-2.2a4 4 0 0 1 .97-2.98l1.45-1.67a4 4 0 0 0 0-5.24l-1.45-1.67a4 4 0 0 1-.97-2.97l.2-2.2a4 4 0 0 0-3.09-4.25l-2.15-.5a4 4 0 0 1-2.53-1.84l-1.14-1.9a4 4 0 0 0-5-1.62l-2.03.87a4 4 0 0 1-3.12 0l-2.04-.87a4 4 0 0 0-4.99 1.62l-1.14 1.9a4 4 0 0 1-2.53 1.84l-2.15.5a4 4 0 0 0-3.09 4.24l.2 2.2a4 4 0 0 1-.97 2.98l-1.45 1.67a4 4 0 0 0 0 5.24l1.45 1.67a4 4 0 0 1 .97 2.97l-.2 2.2a4 4 0 0 0 3.09 4.25l2.15.5a4 4 0 0 1 2.53 1.84l1.14 1.9a4 4 0 0 0 5 1.62l2.03-.87zM152 207a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm6 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-11 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm3-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-8 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm3 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4-6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm6-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-4-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-5-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-24 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm16 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm7-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm86-29a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm19 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-14 5a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-25 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm9 0a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm15 1a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm12-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-11-14a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-19 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm6 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-25 15c0-.47.01-.94.03-1.4a5 5 0 0 1-1.7-8 3.99 3.99 0 0 1 1.88-5.18 5 5 0 0 1 3.4-6.22 3 3 0 0 1 1.46-1.05 5 5 0 0 1 7.76-3.27A30.86 30.86 0 0 1 246 184c6.79 0 13.06 2.18 18.17 5.88a5 5 0 0 1 7.76 3.27 3 3 0 0 1 1.47 1.05 5 5 0 0 1 3.4 6.22 4 4 0 0 1 1.87 5.18 4.98 4.98 0 0 1-1.7 8c.02.46.03.93.03 1.4v1h-62v-1zm.83-7.17a30.9 30.9 0 0 0-.62 3.57 3 3 0 0 1-.61-4.2c.37.28.78.49 1.23.63zm1.49-4.61c-.36.87-.68 1.76-.96 2.68a2 2 0 0 1-.21-3.71c.33.4.73.75 1.17 1.03zm2.32-4.54c-.54.86-1.03 1.76-1.49 2.68a3 3 0 0 1-.07-4.67 3 3 0 0 0 1.56 1.99zm1.14-1.7c.35-.5.72-.98 1.1-1.46a1 1 0 1 0-1.1 1.45zm5.34-5.77c-1.03.86-2 1.79-2.9 2.77a3 3 0 0 0-1.11-.77 3 3 0 0 1 4-2zm42.66 2.77c-.9-.98-1.87-1.9-2.9-2.77a3 3 0 0 1 4.01 2 3 3 0 0 0-1.1.77zm1.34 1.54c.38.48.75.96 1.1 1.45a1 1 0 1 0-1.1-1.45zm3.73 5.84c-.46-.92-.95-1.82-1.5-2.68a3 3 0 0 0 1.57-1.99 3 3 0 0 1-.07 4.67zm1.8 4.53c-.29-.9-.6-1.8-.97-2.67.44-.28.84-.63 1.17-1.03a2 2 0 0 1-.2 3.7zm1.14 5.51c-.14-1.21-.35-2.4-.62-3.57.45-.14.86-.35 1.23-.63a2.99 2.99 0 0 1-.6 4.2zM275 214a29 29 0 0 0-57.97 0h57.96zM72.33 198.12c-.21-.32-.34-.7-.34-1.12v-12h-2v12a4.01 4.01 0 0 0 7.09 2.54c.57-.69.91-1.57.91-2.54v-12h-2v12a1.99 1.99 0 0 1-2 2 2 2 0 0 1-1.66-.88zM75 176c.38 0 .74-.04 1.1-.12a4 4 0 0 0 6.19 2.4A13.94 13.94 0 0 1 84 185v24a6 6 0 0 1-6 6h-3v9a5 5 0 1 1-10 0v-9h-3a6 6 0 0 1-6-6v-24a14 14 0 0 1 14-14 5 5 0 0 0 5 5zm-17 15v12a1.99 1.99 0 0 0 1.22 1.84 2 2 0 0 0 2.44-.72c.21-.32.34-.7.34-1.12v-12h2v12a3.98 3.98 0 0 1-5.35 3.77 3.98 3.98 0 0 1-.65-.3V209a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-24c.01-1.53-.23-2.88-.72-4.17-.43.1-.87.16-1.28.17a6 6 0 0 1-5.2-3 7 7 0 0 1-6.47-4.88A12 12 0 0 0 58 185v6zm9 24v9a3 3 0 1 0 6 0v-9h-6z'/%3E%3Cpath d='M-17 191a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm19 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1zm-14 5a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-25 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm9 0a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm15 1a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm12-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2H4zm-11-14a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-19 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm6 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-25 15c0-.47.01-.94.03-1.4a5 5 0 0 1-1.7-8 3.99 3.99 0 0 1 1.88-5.18 5 5 0 0 1 3.4-6.22 3 3 0 0 1 1.46-1.05 5 5 0 0 1 7.76-3.27A30.86 30.86 0 0 1-14 184c6.79 0 13.06 2.18 18.17 5.88a5 5 0 0 1 7.76 3.27 3 3 0 0 1 1.47 1.05 5 5 0 0 1 3.4 6.22 4 4 0 0 1 1.87 5.18 4.98 4.98 0 0 1-1.7 8c.02.46.03.93.03 1.4v1h-62v-1zm.83-7.17a30.9 30.9 0 0 0-.62 3.57 3 3 0 0 1-.61-4.2c.37.28.78.49 1.23.63zm1.49-4.61c-.36.87-.68 1.76-.96 2.68a2 2 0 0 1-.21-3.71c.33.4.73.75 1.17 1.03zm2.32-4.54c-.54.86-1.03 1.76-1.49 2.68a3 3 0 0 1-.07-4.67 3 3 0 0 0 1.56 1.99zm1.14-1.7c.35-.5.72-.98 1.1-1.46a1 1 0 1 0-1.1 1.45zm5.34-5.77c-1.03.86-2 1.79-2.9 2.77a3 3 0 0 0-1.11-.77 3 3 0 0 1 4-2zm42.66 2.77c-.9-.98-1.87-1.9-2.9-2.77a3 3 0 0 1 4.01 2 3 3 0 0 0-1.1.77zm1.34 1.54c.38.48.75.96 1.1 1.45a1 1 0 1 0-1.1-1.45zm3.73 5.84c-.46-.92-.95-1.82-1.5-2.68a3 3 0 0 0 1.57-1.99 3 3 0 0 1-.07 4.67zm1.8 4.53c-.29-.9-.6-1.8-.97-2.67.44-.28.84-.63 1.17-1.03a2 2 0 0 1-.2 3.7zm1.14 5.51c-.14-1.21-.35-2.4-.62-3.57.45-.14.86-.35 1.23-.63a2.99 2.99 0 0 1-.6 4.2zM15 214a29 29 0 0 0-57.97 0h57.96z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`;
    }
    // document.body.style.backgroundColor = this.theme.body.backgroundColorDEFAULT;
    if (!this.menuHash) {
      this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    }
    })
      .catch(() => {
          const isThemeStored = window.localStorage.getItem("theme");
          if (isThemeStored || !this.$route.params.menuHash){
              this.isThemeLoading = false;
            }else {
              this.isThemeLoading = true;
            }
      });
        // Integerating smartlook in the kiosk mode
        if (this.hasKiosk) {
            window.smartlook || (function(d) {
            var o = window.smartlook=function(){
                o.api.push(arguments)
            },
                h=d.getElementsByTagName('head')[0];
                var c=d.createElement('script');
                o.api=new Array();
                c.async=true;
                c.type='text/javascript';
                c.charset='utf-8';
                c.src='https://web-sdk.smartlook.com/recorder.js';
                h.appendChild(c);
            })(document);
            window.smartlook('init', '140fe8755fb6610cda3137df4a9f1f16c88d191f', { region: 'eu' });
        }
  },
  updated() {
    this.imageWidth = this.orderTypeIconSize != '' ? this.orderTypeIconSize : '4rem'
      if (this.menu.is_disable_takeaway_w_deliv && !this.homeDelivery) {
        localStorage.setItem("delivery", true);
        localStorage.setItem("currentOption", "Delivery");
        this.$store.commit("Cart/updateHomeDelivery", true);
      }
      if (this.menu.landing_page_hash) {
        this.$store.commit(
          "updateLandingsPageDelivery",
          this.menu.landing_page_hash
        );
      }
      document.documentElement.style.setProperty(
        "--rounded-xxl",
        this.menu.is_square_layout ? "0px" : "2rem"
      );
      document.documentElement.style.setProperty(
        "--rounded-xl",
        this.menu.is_square_layout ? "0px" : "1rem"
      );
      document.documentElement.style.setProperty(
        "--rounded-md",
        this.menu.is_square_layout ? "0px" : "0.375rem"
      );
      document.documentElement.style.setProperty(
        "--rounded-lg",
        this.menu.is_square_layout ? "0px" : "0.5rem"
      );

      document.documentElement.style.setProperty(
        "--rounded-full",
        this.menu.is_square_layout ? "0px" : "9999px"
      );

    this.$store.commit(
      "updateCurrentKioskMode",
      localStorage.getItem("kioskOption")
    );
    if (this.hasKiosk) {
      this.$cookies.remove("n");
      this.$cookies.remove("p");
      this.$cookies.remove("v");
    }
    this.$store.commit("updateRouteName", this.$route.name);
    if (["KioskStart","PickUpScreen"].includes(this.$route.name) && this.cartItems.length == 0) {
      this.$store.commit("resetIdleTimer", false);
    } else {
      this.$store.commit("resetIdleTimer", true);
    }

    if (this.showUpselling) {
      this.$modal.show("upselling-items");
    }

    if(this.hasKiosk){
      /* get the custom css colors for the kiosk navigation errors */
      let prev = document.getElementsByClassName("prev")[0];
      let next = document.getElementsByClassName("next")[0];
  
      if (prev) {
        prev.style.backgroundColor = this.kioskArrowBackground;
        prev.style.color = this.kioskArrow;
      }
      if (next) {
        next.style.backgroundColor = this.kioskArrowBackground;
        next.style.color = this.kioskArrow;
      }
    if (this.$route.params.tableId && this.menu.pos_mode == "table-manual") {
      this.$store.commit("Cart/updateTableManual", this.$route.params.tableId);
    }
    }else{
      if (this.$route.params.stickerId && this.menu.pos_mode == "table-manual") {
        this.$store.commit(
          "Cart/updateTableManual",
          this.$route.params.stickerId
        );

    }

    this.$store.commit("Theme/updateSelectedTheme", this.theme);
    if (this.orderStatus != "") {
      if (
        this.orderStatus == "PaymentPending" &&
        this.$route.name != "OrderDetails"
      ) {
        this.$modal.show("retry-payment");
      } else {
        if (this.orderStatus != "New" && this.$route.name != "OrderDetails") {
          this.$store.commit("Cart/removeOrderChunks");
          // sessionStorage.setItem(
          //   "sessionId",
          //   [...Array(30)].map(() => Math.random().toString(36)[2]).join("")
          // );
          if (this.hasKiosk) {
            location.href = `/${this.menuHash}/${
              this.tableId ? this.tableId : 0
            }/order-details?sessionId=${sessionStorage.getItem(
              "sessionId"
            )}&mode=kiosk`;
          } else {
            // saveNewSessionId("App > updated:2675");
          this.$store.dispatch("CREATE_NEW_SESSION_ID")

          }

          if (this.$route.name != "Home" && !this.hasKiosk) {
            if (this.$route.params.tableId) {
              location.href = `/${this.menuHash}/${this.$route.params.tableId}`;
            } else {
              location.href = `/${this.menuHash}`;
            }
          }
        }
      }
    }
    if (this.$browserDetect.isIOS) {
      this.$store.commit("updateIsIOS", true);
    }
    if (this.$browserDetect.isChromeIOS) {
      this.$store.commit("updateisIOSChrome", true);
    }

    // if (parseInt(localStorage.getItem("stickerId")) > 0) {
    //   if(this.hasKiosk){
    //     return (
    //       (this.stickerId = localStorage.getItem("stickerId")),
    //       (this.tableId = localStorage.getItem("stickerId"))
    //     );
    //   }else{
    //     return (this.stickerId = localStorage.getItem("stickerId"));

    //   }
    // }
    if (
      this.menu.enable_delivery &&
      this.isDelivery &&
      !localStorage.getItem("currentOption") &&
      this.$route.name != "OrderDetails" &&
      this.$route.name != "PickUpScreen" &&
      !this.hasKiosk
    ) {
      this.$router
        .push({
          name: "DeliveryStart",
          params: { menuHash: this.menuHash },
        })
        .catch(() => {});
      this.$store.commit("updateIsDelivery", false);
    }
    if (!this.menu.enable_delivery && this.menu.enable_delivery != undefined) {
      localStorage.removeItem("currentOption");
      localStorage.removeItem("delivery");
    }
    this.currentOption = localStorage.getItem("currentOption");
    this.$store.commit("updateSubCategoryId", this.$route.params.subCategoryId);
    let path = "";
    let pointer = "";
    let label = "";
    let onClickIndex;
    let routeName;
    let processBarUpdate;
    if (this.menu.pos_mode) {
      switch (this.processCurrentName) {
        case "Category": {
          if (
            this.menu.timeslots_mode == "general" ||
            this.menu.timeslots_mode == "individual"
          ) {
            if (this.menu.pos_mode == "take-out") {
              this.$store.commit(
                "updateFloatButtonLabel",
                lang["select_time_slot"][this.language]
              );
              this.$store.commit(
                "updateProcessCurrentName",
                "TimeSlotSelection"
              );
              this.$store.commit("updateProcessStack", "TimeSlotSelection");
            } else {
              if (this.stickerId == 0) {
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["select_table"][this.language]
                );
                this.$store.commit(
                  "updateProcessCurrentName",
                  "TableSelection"
                );
                this.$store.commit("updateProcessStack", "TableSelection");
                if (this.menu.pos_mode == "table") {
                  this.$store.commit("updateShowTable", true);
                } else {
                  this.$store.commit("updateShowTableManual", true);
                }
              } else {
                if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                } else {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit("updateShowPayment", true);
                }
              }
            }
          } else {
            if (this.menu.pos_mode == "take-out") {
              if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["leave_contact_details"][this.language]
                );
                this.$store.commit("updateProcessCurrentName", "UserDetails");
                this.$store.commit("updateProcessStack", "UserDetails");
              } else {
                if (
                  (this.menu.timeslots_mode == "simple" ||
                  this.menu.timeslots_mode == "") && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)
                ) {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                } else {
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                }
              }
            } else {
              if (this.stickerId == 0) {
                path = `/${this.menuHash}/cart/table-selection`;
                this.$store.commit(
                  "updateFloatButtonLabel",
                  lang["select_table"][this.language]
                );
                this.$store.commit(
                  "updateProcessCurrentName",
                  "TableSelection"
                );
                this.$store.commit("updateProcessStack", "TableSelection");
                if (this.menu.pos_mode == "table") {
                  this.$store.commit("updateShowTable", true);
                } else {
                  this.$store.commit("updateShowTableManual", true);
                }
              } else {
                if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
                  path = `/${this.menuHash}/cart/user-details`;
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][this.language]
                  );
                  this.$store.commit("updateProcessCurrentName", "UserDetails");
                  this.$store.commit("updateProcessStack", "UserDetails");
                  this.$store.commit("updateShowForm", true);
                } else {
                  path = `/${this.menuHash}/cart/payment`;
                  this.$store.commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][this.language]
                  );

                  this.$store.commit(
                    "updateButtonStack",
                    lang["continue_to_payment"][this.language]
                  );
                  this.$store.commit("updateProcessBarCurrentItem", 3);
                  this.$store.commit("updateProcessBarIndex", 2);
                  this.$store.commit("updateProcessCurrentName", "Payment");
                  this.$store.commit("updateProcessStack", "Payment");
                  this.$store.commit("updateShowPayment", true);
                }
              }
            }
          }
          return {
            visibility: true,
            EnablePossible: pointer,
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: true,
            showItems: false,
            onClickIndex: onClickIndex,
            routeName: routeName,
            processBarUpdate: processBarUpdate,
          };
        }
      }
    }
    }
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    if(this.hasKiosk){
      if (localStorage.getItem("theme") == null) {
        this.$store.commit("setCurrentTheme", "default");
      }
    }
    this.$store.commit("Theme/updateSelectedTheme", this.theme);
    if (localStorage.getItem("delivery")) {
      this.$store.commit("Cart/updateHomeDelivery", true);
    }
    this.currentOption = localStorage.getItem("currentOption");

    // check for kisok mode
    const getUrl = new URL(window.location.href);
    const hasMode = getUrl.searchParams.get("mode");
    if (hasMode) {
      this.$store.commit("updateHasKiosk", true);
    } else {
      this.$store.commit("updateHasKiosk", false);
    }
    if(!this.hasKiosk){
      // stores the current params from the url in here that matches the hotelParams values
      let currentHotelParams = [];
      // check if there are querys that matches the hotelParams array and store them in the localstorage
      this.hotelParams.map((x) => {
        if (this.$route.query[x]) {
          localStorage.setItem(x, this.$route.query[x]);
        }
        if (localStorage.getItem(x)) {
          currentHotelParams.push({ name: x, data: localStorage.getItem(x) });
        }
      });
      // check if the currenthotelparams array has a length to update the route for the user
      if (currentHotelParams.length) {
        let currentPath = this.$route.path;
        this.$router.push(
          `${currentPath}${currentHotelParams
            .map((x, i) => `${i == 0 ? "?" : "&"}${x.name}=${x.data}`)
            .join("")}`
        );
      }
    }
  },
  watch: {
    cartItems() {
      this.additionPrice = [];
      this.filteredAdditionPrice = null;
      this.correctItemPrice();
    },
    menu: {
      deep:true,
      immediate:true,
      handler() {
        let title = "QR Menu App | Menu";
        if (this.menu[`name_${this.language}`]) title = this.menu[`name_${this.language}`];
        document.title = title;
      }
    }
  },
};
</script>
<style>
.language a::after {
  content: " / ";
}
.language a:last-of-type::after {
  content: "";
}

.cartKioskBtn {
  /* left: 50%;
  transform: translateX(-50%); */
  left: 0px;
  right: 0px;
  margin: auto;
}

.test {
  height: 100%;
  overflow-y: scroll;
}

.kioskDeleteItem:hover {
  transition: all 1s ease-in-out;
  transform: scale(1.25);

}


.kioskDeleteItem {
  width: 2.5rem;
  height: 2.5rem;
  position: absolute;
  top: -1rem;
  right: -1rem;
}

.CartItem__title {
  max-width: 50vh;
  min-width: 13ch;
  line-height: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.deleteButtonRight {
  position: absolute;
  top: 15px;
  right: 15px;
}

.CartItem--shadow {
  /* -webkit-box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.05); */

  box-shadow: 0px 0px 6px 2px rgb(0 0 0 / 5%), 0px 5px 10px 0px #00000003;
}
.slide-enter,
.slide-leave-to {
  /* transform: translate(0, 100%); */
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 1s ease;
}
.fixedDesktopCart {
  position: fixed;
  bottom: 30px;
  right: 3rem;
}

.animatedViewOrderButton {
  animation: 1s ease-out 0s 1 zoomInAndOut !important;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter {
  transform : translateX(-100%);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes zoomInAndOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@font-face {
  font-family:"Printvetica";
  src: url(../public/Printvetica.otf)  format('opentype');
}

@font-face {
  font-family: "Freigeist";
  src: url(../public/freigeist-xconblack.ttf);
}

@font-face {
  font-family: "Acumin";
  src: url(../public/Acumin.otf);
}
</style>
